import { CombinatorRendererProps, isOneOfControl, OwnPropsOfControl, RankedTester, rankWith } from '@jsonforms/core';
import { withJsonFormsOneOfProps } from '@jsonforms/react';
import { Button, Group, Select } from '@mantine/core';
import { MantineOneOfBase, OneOfComponentProps } from './MantineOneOfBase';

export interface OwnOneOfProps extends OwnPropsOfControl {
  indexOfFittingSchema?: number;
}

const Buttons = ({ onChange, value, data }: OneOfComponentProps) => {
  return (
    <Group wrap='nowrap' gap='xs'>
      {data.map((label) => (
        <Button key={label} onClick={() => onChange(label)} variant={value === label ? 'filled' : 'default'}>
          {label}
        </Button>
      ))}
    </Group>
  );
};

export const MantineOneOfRenderer = (props: CombinatorRendererProps) => {
  return <MantineOneOfBase Component={Buttons} {...props} />;
};

export const mantineOneOfControlTester: RankedTester = rankWith(4, isOneOfControl);

export default withJsonFormsOneOfProps(MantineOneOfRenderer);
